import { h, Component } from 'preact';
import { loadPage } from 'utils/pageComponents';
import { IntentDetector } from 'utils/intentDetector';
import { getLink } from 'utils/navigation';

export default class PageLink extends Component {

	constructor(props) {
		super(props);
		this.intentDetector = new IntentDetector({
			getBaseEvent: (name) => this.props[name],
			onIntent: this.onIntent.bind(this),
		});
	}

	componentWillUnmount() {
		this.intentDetector.dispose();
	}

	onIntent() {
		loadPage(this.props.to);
	}

	getLinkAttributes() {
		const { to, movie, slug, query, children, ...rest } = this.props;
		const destination = getLink(to, { movie, slug, query });
		if (!destination) return rest;
		if (destination.external) {
			return { href: destination.href, target: '_blank', ...rest };
		}
		return { href: destination.href, ...rest, ...this.intentDetector.events };
	}

	render(props) {
		return (
			<a {...this.getLinkAttributes()}>
				{props.children}
			</a>
		);
	}

}